"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.denmarkTranslations = void 0;
var _types = require("../../../types");
const denmarkTranslations = exports.denmarkTranslations = {
  [_types.ErrorPageTranslationKey.headline]: 'Vi Beklager!',
  [_types.ErrorPageTranslationKey.buttonText]: 'Tilbage',
  [_types.ErrorPageTranslationKey.text]: 'Denne side er utilgængelig i øjeblikket',
  [_types.ErrorPageTranslationKey.notFound]: 'Den søgte side virker ikke',
  [_types.ErrorPageTranslationKey.unauthorized]: 'Den side, du forsøger at nå, er begrænset, og ikke alle kriterier blev opfyldt.',
  [_types.ErrorPageTranslationKey.contactSupportTeam]: 'Kontakt venligst Oriflames supportteam via e-mail:',
  [_types.ErrorPageTranslationKey.rejectedUrl]: 'Den anmodede URL blev afvist!'
};
